import type { CheckoutWebComponents, Component } from '@checkout.com/checkout-web-components'
import { BaseCheckoutPayFlowModule, PAYMENT_EXECUTION_MODE, type PaymentExecutionMode } from './BaseCheckoutPayFlowModule'
import { PAYMENT_DIALOG_TYPE, type PaymentDialogType } from './payment-dialog-type'

export class CheckoutPayAlipayHkModule extends BaseCheckoutPayFlowModule {
  protected createComponent(
    checkout: CheckoutWebComponents,
    callbacks: Parameters<BaseCheckoutPayFlowModule['createComponent']>[1],
  ): Component {
    // 自帶按鈕（showPayButton:false）時 Flow 不會自動跳轉；改用 Flow 原生付款鈕，
    // 由 Flow 自己處理 submit + 整頁 redirect（在彈窗內呈現）。
    return checkout.create('alipay_hk', { ...callbacks, showPayButton: true })
  }

  public override getPaymentExecutionMode(): PaymentExecutionMode {
    return PAYMENT_EXECUTION_MODE.CKO_REDIRECT
  }

  public override mountsInDialog(): boolean {
    return true
  }

  public override getPaymentDialogType(): PaymentDialogType | null {
    return PAYMENT_DIALOG_TYPE.ALIPAY_HK
  }
}
